<form [formGroup]="$any(form)" (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title *ngIf="data.title">{{ data.title }}</h1>

  <div mat-dialog-content>
    <mat-form-field *ngFor="let control of form.controls; let i = index">
      <mat-label>Translation</mat-label>
      <atm-translation-input
        [type]="data.type"
        [formControlName]="i"
      ></atm-translation-input>

      <button
        type="button"
        matSuffix
        mat-icon-button
        (click)="form.removeAt(i)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="add()">Add</button>
    <button
      mat-raised-button
      color="primary"
      cdkFocusInitial
      [disabled]="form.invalid"
    >
      Validate
    </button>
  </mat-dialog-actions>
</form>
